import * as React from "react";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";
import { ENHANCED_MARKET } from "@bundles/consts";
import Props from "./IMembershipPage";
import { setFundsData } from "@funds/features/action.funds";
import "../../../../styles/tailwind-output.css";
import { BuildBitcoinWealth } from "./components/sections/BuildBitcoinWealth/BuildBitcoinWealth";
import { WhatTypeOfInvestor } from "./components/sections/WhatTypeOfInvestor/WhatTypeOfInvestor";
import { BFCardsList } from "./components/BFCards/BFCards";
import { Accordion } from "./components/Accordion/Accordion";
import BFAccordionIcon from "./images/bf-accordion-icon.svg";
import TrackProgressIcon from "./images/track-progress-icon.svg";
import { BitcoinInvestmentPlatformFooter } from "./components/BitcoinInvestmentPlatformFooter/BitcoinInvestmentPlatformFooter";
import { TopSection } from "./components/sections/TopSection/TopSection";
import {
  MembershipPageProvider,
  useMembershipPageContext,
} from "./MembershipPage.context";
import { TrackProgressDescription } from "./components/sections/TrackProgressDescription/TrackProgressDescription";
import { TrackProgress } from "./components/sections/TrackProgress/TrackProgress";

import * as style from "./MembershipPageStyles.module.scss"

export const MembershipPageBase = ({
  userInfo,
  isUkInvestor,
  slug,
  userTier,
  isUserHNW,
  bitcoinJourneyStep,
}: Props) => {
  const {
    isInvestmentPlatformAccordionOpen,
    setInvestmentPlatformAccordionOpen,
    isTrackProgressAccordionOpen,
    setIsTrackProgressAccordionOpen,
  } = useMembershipPageContext();
  return (
    <div className="tailwind">
      <div className="bg-gradient-to-b from-[#560e99] to-[#81109c] absolute left-0 right-0 h-[272px]" />

      <div className={`${style.pageWrapper} pt-8`}>
        <div className="bg-white max-w-[1140px] relative top-0 my-0 mx-auto mb-[50px] p-8 overflow-hidden">
          <TopSection className="mb-[48px]" userInfo={userInfo} />

          <Accordion
            icon={
              <BFAccordionIcon className="md:h-auto md:w-auto h-[35px] w-[35px]" />
            }
            title="Using our All-In-One Bitcoin Investment platform"
            isOpen={isInvestmentPlatformAccordionOpen}
            setIsOpen={setInvestmentPlatformAccordionOpen}
          >
            <BFCardsList isUk={isUkInvestor} />

            <BuildBitcoinWealth
              bitcoinJourneyStep={bitcoinJourneyStep}
              slug={slug}
              isUk={isUkInvestor}
            />

            <WhatTypeOfInvestor
              isUk={isUkInvestor}
              isHNW={isUserHNW}
              userTier={userTier}
            />

            <BitcoinInvestmentPlatformFooter isUk={isUkInvestor} />
          </Accordion>

          <Accordion
            icon={
              <TrackProgressIcon className="md:h-auto md:w-auto h-[35px] w-[35px]" />
            }
            title="Track Your Progress"
            className="mt-4"
            isOpen={isTrackProgressAccordionOpen}
            setIsOpen={setIsTrackProgressAccordionOpen}
          >
            <TrackProgressDescription isUk={isUkInvestor} />

            <TrackProgress
              currentStep={bitcoinJourneyStep}
              slug={slug}
              isUk={isUkInvestor}
            />
          </Accordion>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store: TReducers) => {
  return {
    appSettings: store.appSettings,
    userInfo: store.userInfo,
    supportedUserWallets: store.fundsReducer.supportedUserWallets,
    isUsInvestor: ENHANCED_MARKET.includes(store.userInfo.country),
    isUkInvestor: store.userInfo.country === "GB",
    slug: store.userInfo.nickname,
    userTier: store.userInfo.tier,
    isUserHNW: store.userInfo.hnw,
    bitcoinJourneyStep: store.userInfo.bitcoin_journey_step ?? 0,
  };
};

const mapDispatchToProps = (dispatch: Function) => ({
  setFundsData: (investorId: number) => dispatch(setFundsData(investorId)),
});

export const MembershipPage = (props: Props) => {
  return (
    <MembershipPageProvider>
      <MembershipPageBase {...props} />
    </MembershipPageProvider>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MembershipPage);
